export const cancelRfe = {
	title: "Annuler ma Plateforme Agréée",
	stepper: {
		scope: "Périmètre",
		substitutes: "Remplaçants",
		recap: "Confirmation"
	},
	scope: {
		title: "Que souhaitez-vous annuler ?",
		'principal-label': "Annuler mon pack RFE (titulaire)",
		'principal-help': "Votre PA sera annulée. Tous les packs RFE activés pour vos remplaçants seront automatiquement annulés.",
		'substitutes-label': "Annuler uniquement le pack RFE des remplaçants",
		'substitutes-help': "Votre PA reste active. Seules les Plateformes Agréées des remplaçants sélectionnés seront annulées."
	},
	principal: {
		'cascade-warning': "L'annulation de votre PA entraîne automatiquement l'annulation de tous les packs RFE de vos remplaçants."
	},
	substitutes: {
		title: "Quels packs RFE de remplaçants annuler ?",
		subtitle: "Sélectionnez les remplaçants dont vous souhaitez annuler le pack RFE. Votre PA de titulaire n'est pas concernée.",
		'select-all': "tout sélectionner",
		'unselect-all': "tout désélectionner",
		'selected-count': "{count} pack RFE sélectionné | {count} packs RFE sélectionnés",
		'no-substitute': "Aucun remplaçant avec un pack RFE actif."
	},
	reason: {
		label: "Motif de l'annulation",
		placeholder: "Précisez la raison de cette annulation",
		title: "Veuillez indiquer le motif de l'annulation",
		'maxLength-warning': "Le motif ne doit pas dépasser {0} caractères."
	},
	recap: {
		title: "Récapitulatif de l'annulation",
		'line-principal': "Plateforme Agréée (titulaire)",
		'line-principal-sub': "{0}",
		'line-substitute': "Remplaçant : {0}",
		'line-substitute-role': "Pack RFE (remplaçant)",
		'principal-note': "Les packs RFE de vos remplaçants seront annulés en même temps que votre PA.",
		warning: "Cette action annule votre facturation électronique via la Plateforme Agréée. L'annulation est historisée (date et motif conservés)."
	},
	nav: {
		back: "retour",
		next: "suivant",
		cancel: "fermer"
	},
	confirm: "confirmer l'annulation",
	success: "Votre demande d'annulation a bien été prise en compte.",
	failed: "Une erreur est survenue lors de l'annulation. Veuillez réessayer."
}
